'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableComponent(props) {
	var className = (0, _classnames2.default)((0, _defineProperty3.default)({
		'mk-table': true
	}, props.className, !!props.className));
	return _react2.default.createElement(_table2.default, (0, _extends3.default)({}, props, { className: className }));
}

TableComponent.Column = _table2.default.Column;
TableComponent.ColumnGroup = _table2.default.ColumnGroup;
TableComponent.rowSelection = _table2.default.rowSelection;
TableComponent.selection = _table2.default.selection;

exports.default = TableComponent;
module.exports = exports['default'];